export default __webpack_public_path__ + "static/media/4029.1728cde8.png";